import z from "zod";

z.config(z.locales.pt());
